<template>
    <div>
        <EChart
            :options="chartData"
            card
            :header="$t('availabilityInStores')"
            :loading="loading"
            class="shadow-none m-0"
            @click="handleChartClick"
        />
        <ModalAvailabilityInStoresItem />
    </div>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import ModalAvailabilityInStoresItem from './ModalAvailabilityInStoresItem.vue';

    export default {
        name: 'AvailabilityInStores',
        components: {
            EChart,
            ModalAvailabilityInStoresItem,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestReportSet: this.parentComponent.requestReportSet,
                requestReport: this.parentComponent.requestReport,
            };
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
            currentItem() {
                return this.parentComponent.currentItem;
            },
            productSet() {
                return this.parentComponent.productSet || [];
            },
            currentSet() {
                if (!this.currentItem?.reportId) return null;
                return this.productSet.find(setEntry => setEntry.reportId === this.currentItem.reportId) || null;
            },
            productsInSet() {
                return this.currentSet?.allProducts || [];
            },
            rowsForChart() {
                if (!this.productsInSet.length) return [];
                return this.productsInSet.map(productMeta => this.parentComponent.getDataForSet(this.productsInSet, productMeta.id, productMeta.type)).filter(Boolean);
            },
            chartData() {
                if (!this.rowsForChart.length) return { series: [] };

                // etykiety Y + meta do klików
                const yAxisData = this.rowsForChart.map(row => {
                    const productLabel = `${row.name} (ID: ${row.id})`;
                    return { value: productLabel, metaData: row };
                });

                // zakresy [start, end] na osi czasu dla każdego produktu
                const series = this.rowsForChart.map(row => {
                    const productLabel = `${row.name} (ID: ${row.id})`;
                    const ranges = Array.isArray(row.allPriceOccurrencesAccumulated) ? row.allPriceOccurrencesAccumulated : [];

                    const segments = ranges
                        .map(seg => {
                            const startTs = Number(seg?.start);
                            const endTs = Number(seg?.end);
                            if (!Number.isFinite(startTs) || !Number.isFinite(endTs) || startTs > endTs) return null;
                            return { x: productLabel, y: [startTs, endTs] };
                        })
                        .filter(Boolean);

                    return {
                        name: productLabel,
                        type: 'rangeBar',
                        data: [{ name: productLabel, data: segments }],
                    };
                });

                return {
                    xAxis: { type: 'time' },
                    yAxis: {
                        type: 'category',
                        data: yAxisData,
                        axisLabel: { formatter: val => ` {btn|»}${val}` },
                        triggerEvent: true,
                    },
                    series,
                };
            },
        },
        methods: {
            handleChartClick(params) {
                if (params.componentType === 'yAxis') {
                    const item = this.chartData.yAxis.data[params.dataIndex].metaData;
                    this.showDetails(item);
                }
            },
            showDetails(item) {
                const id = 'ModalAvailabilityInStoresItem';
                this.$root.$emit('bv::show::modal', id);
                this.$root.$emit(id, item);
            },
        },
    };
</script>
